import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/media/icons/duotone/Text/Filter.svg'
import _imports_1 from '@/assets/media/icons/duotone/Communication/More.svg'
import _imports_2 from '@/assets/media/icons/duotone/Navigation/Exchange.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-fde9f08e")

_pushScopeId("data-v-fde9f08e")
const _hoisted_1 = { class: "fs-2" }
const _hoisted_2 = { class: "fs text-gray-600" }
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  key: 0,
  class: "d-inline-flex p-2"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "fas fa-history" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Generate Summary Transaction ")
const _hoisted_7 = {
  href: "#",
  class: "btn btn-sm btn-flex btn-light btn-active-primary fw-bolder",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_8 = { class: "svg-icon svg-icon-5 svg-icon-gray-500 me-1" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Filter ")
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = { class: "dialog-footer" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Confirm ")
const _hoisted_14 = {
  key: 1,
  class: "badge badge-white"
}
const _hoisted_15 = { class: "svg-icon svg-icon-4" }
const _hoisted_16 = { class: "svg-icon svg-icon-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_FilterReport = _resolveComponent("FilterReport")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_router_link = _resolveComponent("router-link")
  const _component_pagination = _resolveComponent("pagination")
  const _component_table_skeleton = _resolveComponent("table-skeleton")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_card = _resolveComponent("el-card")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_el_card, null, {
      default: _withId(() => [
        _createVNode(_component_el_row, { class: "d-flex align-items-center mb-8" }, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("reports.channel.title")), 1),
                _createVNode(_component_el_row, { class: "d-flex justify-content-between" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("reports.channel.subtitle")), 1),
                    _createVNode("div", _hoisted_3, [
                      (_ctx.checkRole(['sysadmin', 'operational']).isGranted)
                        ? (_openBlock(), _createBlock("div", _hoisted_4, [
                            _createVNode(_component_el_date_picker, {
                              size: "small",
                              modelValue: _ctx.transaction.date,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.transaction.date = $event)),
                              "value-format": "YYYY-MM-DD",
                              class: "block"
                            }, null, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.checkRole(['sysadmin', 'operational']).isGranted)
                        ? (_openBlock(), _createBlock("a", {
                            key: 1,
                            class: "btn btn-sm btn-flex btn-info fw-bolder me-20",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showDialog && _ctx.showDialog(...args)))
                          }, [
                            _hoisted_5,
                            _hoisted_6
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("a", _hoisted_7, [
                        _createVNode("span", _hoisted_8, [
                          _createVNode(_component_inline_svg, { src: _imports_0 })
                        ]),
                        _hoisted_9
                      ]),
                      _createVNode(_component_FilterReport, { onFiltered: _ctx.filtered }, null, 8, ["onFiltered"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dialog, {
                  modelValue: _ctx.dialogVisible,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogVisible = $event)),
                  title: "Confirmation",
                  width: "30%"
                }, {
                  footer: _withId(() => [
                    _createVNode("span", _hoisted_11, [
                      _createVNode(_component_el_button, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogVisible = false))
                      }, {
                        default: _withId(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.generate
                      }, {
                        default: _withId(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  default: _withId(() => [
                    _createVNode("span", null, "Are you sure you want to generate " + _toDisplayString(_ctx.transaction.date) + " transaction summary?", 1),
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_table_skeleton, {
                  loading: !_ctx.data || _ctx.isValidating || _ctx.isGenerate
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_table, {
                      class: "Invocation-table mt-8 fs-7",
                      data: _ctx.data?.data,
                      style: {"width":"100%"}
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_table_column, { type: "expand" }, {
                          default: _withId((scope) => [
                            _createVNode(_component_el_table, {
                              class: "mt-8 fs-7",
                              data: scope.row.transfer_history,
                              style: {"width":"100%"}
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_table_column, {
                                  align: "center",
                                  prop: "ref_id",
                                  label: "Transfer Date"
                                }, {
                                  default: _withId((scopeChild) => [
                                    _createTextVNode(_toDisplayString(_ctx.moment(scopeChild.row.created_at).format('YYYY-MM-DD HH:mm:ss')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  align: "center",
                                  prop: "ref_id",
                                  label: "Source Account"
                                }, {
                                  default: _withId((scopeChild) => [
                                    _createTextVNode(_toDisplayString(scopeChild.row.source_account), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  align: "center",
                                  prop: "ref_id",
                                  label: "Destination Bank Code"
                                }, {
                                  default: _withId((scopeChild) => [
                                    _createTextVNode(_toDisplayString(scopeChild.row.destination_bank_code), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  align: "center",
                                  prop: "ref_id",
                                  label: "Destination Account"
                                }, {
                                  default: _withId((scopeChild) => [
                                    _createTextVNode(_toDisplayString(scopeChild.row.destination_account), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  align: "center",
                                  prop: "ref_id",
                                  label: "Account Holder"
                                }, {
                                  default: _withId((scopeChild) => [
                                    _createTextVNode(_toDisplayString(scopeChild.row.account_holder), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  align: "center",
                                  prop: "ref_id",
                                  label: "Status"
                                }, {
                                  default: _withId((scopeChild) => [
                                    _createVNode("span", {
                                      class: 'badge ' + (
                          scopeChild.row.status == 'success' ? 'badge-light-success' :
                            scopeChild.row.status == 'pending' ? 'badge-light-warning' :
                              scopeChild.row.status == 'cancelled' ? 'badge-light-dark' : 'badge-light-danger')
                                    }, _toDisplayString(scopeChild.row.status), 3)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["data"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          align: "center",
                          prop: "ref_id",
                          label: "Tanggal"
                        }, {
                          default: _withId((scope) => [
                            _createTextVNode(_toDisplayString(scope.row.transaction_date), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          align: "center",
                          prop: "ref_id",
                          label: "Channel"
                        }, {
                          default: _withId((scope) => [
                            _createTextVNode(_toDisplayString(scope.row.channel), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          "header-align": "center",
                          prop: "ref_id",
                          label: "Institution"
                        }, {
                          default: _withId((scope) => [
                            _createTextVNode(_toDisplayString(scope.row.institution_name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          "header-align": "center",
                          align: "right",
                          prop: "ref_id",
                          label: "Jumlah Trx"
                        }, {
                          default: _withId((scope) => [
                            _createTextVNode(_toDisplayString(scope.row.sum_trx), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          "header-align": "center",
                          align: "right",
                          prop: "ref_id",
                          label: "Total Amount"
                        }, {
                          default: _withId((scope) => [
                            _createTextVNode(_toDisplayString(_ctx.numberFormat(parseInt(scope.row.sum_amount))), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          "header-align": "center",
                          align: "center",
                          prop: "status",
                          label: "Status Transfer"
                        }, {
                          default: _withId((scope) => [
                            (scope.row.status != null)
                              ? (_openBlock(), _createBlock("span", {
                                  key: 0,
                                  class: 'badge ' + (
                    scope.row.status == 'success' ? 'badge-light-success' :
                      scope.row.status == 'pending' ? 'badge-light-warning' :
                      scope.row.status == 'waiting' ? 'badge-white' :
                        scope.row.status == 'cancelled' ? 'badge-light-dark' : 'badge-light-danger')
                                }, _toDisplayString(scope.row.status), 3))
                              : (_openBlock(), _createBlock("span", _hoisted_14, "waiting"))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          "header-align": "center",
                          align: "right",
                          prop: "ref_id",
                          label: "Action"
                        }, {
                          default: _withId((scope) => [
                            _createVNode(_component_el_tooltip, {
                              class: "box-item",
                              effect: "dark",
                              content: "Detail",
                              placement: "left"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_router_link, {
                                  to: {
                      path: '/app/payment',
                      query: {
                        channel: scope.row.channel,
                        date: [scope.row.transaction_date, scope.row.transaction_date],
                        ts: _ctx.moment().format('YYYY-MM-DDTHH:mm:ss.SSS')
                      }
                    },
                                  custom: ""
                                }, {
                                  default: _withId(({ href, navigate }) => [
                                    _createVNode(_component_el_tooltip, {
                                      class: "box-item",
                                      effect: "dark",
                                      content: "Detail",
                                      placement: "bottom"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode("a", {
                                          class: "btn btn-sm btn-icon btn-success mt-2 ms-2",
                                          href: href,
                                          onClick: navigate
                                        }, [
                                          _createVNode("span", _hoisted_15, [
                                            _createVNode(_component_inline_svg, { src: _imports_1 })
                                          ])
                                        ], 8, ["href", "onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              _: 2
                            }, 1024),
                            (_ctx.checkPermission('submit-overbooking').isGranted && (scope.row.status == null || scope.row.status == 'cancelled'
                    || scope.row.status == 'failed' || scope.row.status == 'waiting'))
                              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                  key: 0,
                                  class: "box-item",
                                  effect: "dark",
                                  content: "Overbooking",
                                  placement: "bottom"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_router_link, {
                                      to: {
                        path: '/app/finance/overbooking',
                        query: {
                          amount: parseInt(scope.row.sum_amount),
                          type: 'institution',
                          holder: scope.row.institution_id,
                          channel: scope.row.channel,
                          summary_id: scope.row.id,
                          ts: _ctx.moment().format('YYYY-MM-DDTHH:mm:ss.SSS')
                        }
                      },
                                      custom: ""
                                    }, {
                                      default: _withId(({ href, navigate }) => [
                                        _createVNode(_component_el_tooltip, {
                                          class: "box-item",
                                          effect: "dark",
                                          content: "Overbooking",
                                          placement: "bottom"
                                        }, {
                                          default: _withId(() => [
                                            _createVNode("a", {
                                              class: "btn btn-sm btn-icon btn-info mt-2 ms-2",
                                              href: href,
                                              onClick: navigate
                                            }, [
                                              _createVNode("span", _hoisted_16, [
                                                _createVNode(_component_inline_svg, { src: _imports_2 })
                                              ])
                                            ], 8, ["href", "onClick"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"]),
                    (_ctx.data && _ctx.data.current_page)
                      ? (_openBlock(), _createBlock(_component_pagination, {
                          key: 0,
                          onChange: _ctx.handleChangePage,
                          ref: "paginationRef",
                          class: "mt-8",
                          "hide-when-only-one-page": true,
                          page: _ctx.data.current_page,
                          "per-page": _ctx.data.per_page ?? 0,
                          "total-current-page-item": _ctx.data.data.length,
                          "total-all-items": _ctx.data.total ?? 0
                        }, null, 8, ["onChange", "page", "per-page", "total-current-page-item", "total-all-items"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
})